import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import LiquidEther from './LiquidEther';

const Hero = () => {
  return (
    <section className="relative w-full h-screen flex items-center justify-center overflow-hidden bg-[#0A1931]">
      
      {/* Animation de fond */}
      <div className="absolute inset-0 z-0">
        <LiquidEther color0="#4a7fa7" color1="#b3cfe5" color2="#0A1931" autoIntensity={2.2} />
        <div className="absolute inset-0 bg-[#0A1931]/40 z-[1]" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-20">
        
        {/* Légende */}
        <motion.div 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white text-[12px] font-bold uppercase tracking-[0.2em] mb-8"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#B3CFE5] animate-pulse" />
          Leader en sécurité offensive
        </motion.div>

        {/* H1 */}
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-[32px] md:text-[40px] font-black text-[#F6FAFD] leading-[1.2] mb-6 tracking-tight font-inter"
        >
          Protégez votre entreprise avec <br className="hidden md:block" />
          <span className="text-[#B3CFE5]">Nodixs</span>
        </motion.h1>

        {/* Corps de texte de présentation */}
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-[#F6FAFD]/70 text-[15px] md:text-[16px] max-w-xl mx-auto mb-8 leading-relaxed font-medium font-inter"
        >
          Expertise professionnelle en OSINT et Pentest pour sécuriser vos actifs critiques et anticiper les cybermenaces.
        </motion.p>

        {/* --- NOUVELLE SECTION MARKETING TEXT --- */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="flex flex-col gap-1 mb-10"
        >
          <p className="text-[#B3CFE5]/90 text-[13px] md:text-[14px] font-medium tracking-wide">
            Aujourd’hui, une entreprise peut être compromise sans attaque directe.
          </p>
          <p className="text-[#B3CFE5]/80 text-[13px] md:text-[14px] font-medium tracking-wide">
            Un mot de passe exposé, une fuite de données ou une mauvaise configuration peuvent suffire.
          </p>
          <p className="text-[#B3CFE5]/70 text-[13px] md:text-[14px] font-medium tracking-wide">
            La majorité des cyberattaques exploitent des failles connues non corrigées.
          </p>
        </motion.div>
        {/* --- FIN SECTION MARKETING --- */}

        {/* Boutons */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="flex flex-col sm:flex-row justify-center items-center gap-4"
        >
          <Link to="/rdv">
          <button className="bg-[#0A1931] text-[#F6FAFD] px-7 py-3 rounded-xl font-bold text-[14px] border border-[#B3CFE5]/30 shadow-xl transition-all hover:bg-[#1A3D63]">
            Demander un audit
          </button>
          </Link>
          
          <div className="flex gap-3">
            <Link to="/osint">
              <button 
                className="bg-[#F6FAFD] text-[#0A1931] px-6 py-3 rounded-xl font-bold text-[14px] shadow-md hover:bg-white transition-all">
                OSINT
              </button>
            </Link>

            <Link to="/pentest">
              <button 
                className="bg-[#F6FAFD] text-[#0A1931] px-6 py-3 rounded-xl font-bold text-[14px] shadow-md hover:bg-white transition-all">
                Pentest
              </button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;